import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const renderLabel = ({ name, percent }) =>
  `${name} ${(percent * 100).toFixed(0)}%`;

export default function PieChartWithPaddingAngle({
  apiData,
  isAnimationActive = true,
}) {
  const pieData = React.useMemo(() => {
    if (!apiData || apiData.length === 0) return [];

    const { CashSales, CreditSales, CashReturns, CreditReturns } = apiData[0];

    return [
      { name: "Cash Sales", value: Math.abs(CashSales), fill: "#2663EB" },
      { name: "Credit Sales", value: Math.abs(CreditSales), fill: "#00C49F" },
      { name: "Cash Returns", value: Math.abs(CashReturns), fill: "#FFBB28" },
      {
        name: "Credit Returns",
        value: Math.abs(CreditReturns),
        fill: "#FE165A",
      },
    ].filter((item) => item.value > 0);
  }, [apiData]);

  const totalAmount = pieData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="w-full h-[300px] bg-white rounded-3xl flex items-center justify-center p-4">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {/* Center Text */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-gray-900"
          >
            <tspan x="50%" dy="-0.2em" fontSize="24" fontWeight="600">
              {totalAmount.toLocaleString()}
            </tspan>
          </text>

          <Pie
            data={pieData}
            dataKey="value"
            innerRadius="70%"
            outerRadius="100%"
            cornerRadius="40%"
            paddingAngle={5}
            label={renderLabel}
            labelLine={false}
            isAnimationActive={isAnimationActive}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>

          <Tooltip formatter={(value) => ` ${value.toLocaleString()}`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
